export class CustomerInfoFromSAPPerson {
    code: string;
    firstName: string;
    middleName: string;
    lastName: string;
    lastName2: string;
    birthDate: string;
    sex: string;
    maritalStatus: string;
    nationality: string;
    position: string;
    phoneNumber1: string;
    phoneNumber2: string;
    phoneNumber3: string;
    email: string;
    universityDegree: string;
    children: string;
    ownCar: string;

    constructor() {
        this.code = "";
        this.firstName = "";
        this.middleName = "";
        this.lastName = "";
        this.lastName2 = "";
        this.birthDate = "";
        this.sex = "";
        this.maritalStatus = "";
        this.nationality = "";
        this.position = "";
        this.phoneNumber1 = "";
        this.phoneNumber2 = "";
        this.phoneNumber3 = "";
        this.email = "";
        this.universityDegree = "";
        this.children = "";
        this.ownCar = "";
    }
}